import React, { useMemo } from 'react';

import { Alert, Flex } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import type { YouthSubmitResult } from '@modules/meritBadgeCounselors/mbcBulkEntry/duck/types';
import { groupErrorsByMessage } from '@modules/meritBadgeCounselors/mbcBulkEntry/duck/utils';

import type { ClassRequirement, ClassYouth } from '../types';

interface SaveErrorsAlertProps {
  results: YouthSubmitResult[];
  requirements: ClassRequirement[];
  roster: ClassYouth[];
}

export default function SaveErrorsAlert(props: SaveErrorsAlertProps) {
  const { results, requirements, roster } = props;

  const requirementById = useMemo(
    () => new Map(requirements.map(req => [Number(req.id), req])),
    [requirements],
  );
  const nameByUserId = new Map(roster.map(youth => [youth.userId, youth.name]));

  return (
    <Alert
      type="error"
      showIcon
      message={<FormattedMessage id="page.mbcClassEntry.saveErrors.title" />}
      description={
        <Flex vertical gap={8}>
          {results
            .filter(result => result.errors.length > 0)
            .map(result => (
              <div key={result.userId}>
                <Text strong>
                  {nameByUserId.get(result.userId) ?? result.userId}
                </Text>
                {groupErrorsByMessage(result.errors, requirementById).map(
                  ({ message, reqLabels }) => (
                    <div key={message}>
                      <FormattedMessage
                        id="page.mbcClassEntry.saveErrors.item"
                        values={{ requirements: reqLabels.join(', '), message }}
                      />
                    </div>
                  ),
                )}
              </div>
            ))}
        </Flex>
      }
    />
  );
}
